<template>
  <modal :name="name" class="add-event-modal show-event-modal" height="auto" :reset="true" :draggable="false"
    :class="{ old: event._start_time < now }">
    <div class="modal-header">
      <span class="modal-header-title">
        <a v-if="titleUrl" :href="titleUrl" target="_blank">{{ eventLabel }}</a>
        <template v-else>{{ eventLabel }}</template>
      </span>

      <div class="modal-header-btns">
        <button v-if="(action === 'edit' || action === 'schedule') && canEditEvents" type="button"
          class="btn btn-link btn-with-icon" @click="editEvent">
          <i class="icon-note"></i>
        </button>
        <button v-if="
          (action === 'edit' || action === 'schedule' || action === 'show') &&
          canDeleteEvents &&
          !event.deleted_at
        " type="button" class="btn btn-link btn-with-icon btn-delete" @click="deleteEvent">
          <i class="icon-trash"></i>
        </button>
        <button v-if="showRestore && event.deleted_at" type="button" class="btn btn-link btn-with-icon"
          @click="restoreEvent" data-toggle="tooltip" data-placement="top" v-bind:title="texts.restore_event">
          <i class="icon-action-undo"></i>
        </button>
        <button v-if="showDelete && event.deleted_at" type="button" class="btn btn-link btn-with-icon"
          @click="deleteEventForever" data-toggle="tooltip" data-placement="top"
          v-bind:title="texts.delete_event_forever">
          <i class="icon-trash"></i>
        </button>
        <button type="button" class="btn btn-link btn-with-icon" @click="hide">
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <div v-if="eventBadges.length" class="event-badges">
        <span v-for="(info, i) in eventBadges" :key="'badge-' + i" v-html="info.value"></span>
      </div>
      <p>
        {{ date | format_date("dddd, D MMMM") }} ⋅
        {{ event.start_time | format_date("H:mm") }} –
        {{ event.end_time | format_date("H:mm") }}
      </p>
      <div v-for="(info, i) in eventInfo" :key="'info-' + i">
        <p v-if="!info.type">
          <span v-if="info.key" v-html="info.key + ':'"></span>
          <b v-html="info.value"></b>
        </p>
      </div>
      <div v-for="(component, i) in eventComponents" :key="'component-' + i">
        <component :is="component.name" v-bind="component.props" v-bind:local-event-bus="eventBus"></component>
      </div>
      <div class="loading-spinner" v-if="isLoading">
        <atom-spinner class="navi-spinner" :animation-duration="1000" :size="50" :color="'#ff1d5e'" />
      </div>
    </div>
  </modal>
</template>

<script>
import ModalBase from "./ModalBase.vue";
import { EventCacheAPI } from "../mixins/EventCacheAPI";

export default {
  extends: ModalBase,
  mixins: [EventCacheAPI],

  props: {
    showRestore: {
      default: true,
    },
    showDelete: {
      default: true,
    },
    eventsInfoUrl: {
      default: "",
    },
    canEditEvents: {
      default: true,
    },
    canDeleteEvents: {
      default: true,
    },
  },

  data() {
    return {
      event: {},
      date: moment(),
      eventInfo: [],
      isLoading: false,
    };
  },

  mounted() {
    console.log("Timetable Show Event Modal Component Mounted.");

    this.eventBus.$on("show-event", this.showEvent);
    this.eventBus.$on("show-event-reload", () =>
      this.showEvent(this.event, this.date)
    );
  },

  computed: {
    eventLabel() {
      if (this.event.display_title) return this.event.display_title;
      if (this.event.type === "internal-exam") return this.texts.exam || this.texts.no_title;

      return this.texts.no_title;
    },

    titleUrl() {
      const item = _.find(this.eventInfo, (info) => "title_url" === info.type);
      return item ? item.value : null;
    },

    eventBadges() {
      return _.filter(this.eventInfo, (info) => "badge" === info.type);
    },

    eventComponents() {
      return _.filter(
        this.eventInfo,
        (info) => "component" === info.type // && info.component in Vue.options.components
      );
    },
  },

  methods: {
    showEvent(event, date) {
      this.event = event;
      this.date = date;
      this.eventInfo = [];
      this.getEventInfo();
      this.show();
    },

    getEventInfo(event) {
      if (!this.eventsInfoUrl) return;
      this.isLoading = true;

      var url = this.eventsInfoUrl;
      if (url.includes("__id__")) {
        url = url.replace("__id__", this.event.id);
      } else {
        url += (url.endsWith("/") ? "" : "/") + this.event.id;
      }

      // Verification code is used to know with which response to populate data events
      let verificationCode = this.startRequest("get-event-ingo");

      return axios.get(url).then(
        (response) => {
          // Check if this is the last request
          if (!this.isValidRequest("get-event-ingo", verificationCode)) return;

          this.eventInfo = response.data.info;
          this.isLoading = false;
        },
        (error) => {
          console.log("GET EVENT INFO ERROR", error.response);

          // Mirror the success path's guard: a superseded request must not clear the
          // spinner, because the newer request it lost to is still running.
          if (!this.isValidRequest("get-event-ingo", verificationCode)) return;

          // Without this the modal kept spinning forever on any failure, showing no
          // details, no error and no way to retry short of closing and reopening.
          this.isLoading = false;

          this.$notify({
            group: "app",
            text: error?.response?.data?.message || 'A apărut o eroare. Încercați din nou.',
            type: "error",
          });
        }
      );
    },

    editEvent() {
      this.eventBus.$emit("edit-event", this.event, this.date);
      this.hide();
    },

    deleteEvent() {
      this.eventBus.$emit("delete-event", this.event, this.date);
      this.hide();
    },

    deleteEventForever() {
      this.eventBus.$emit("delete-event-forever", this.event);
      this.hide();
    },

    restoreEvent() {
      this.eventBus.$emit("restore-event", this.event);
      this.hide();
    },
  },
};
</script>
<style>
.btn-delete {
  color: #f86c6b;
}
</style>
